/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { Box } from '@chakra-ui/react'
import React from 'react'
import ItemDetails from '../ItemDetails'
import SectionTitle from '../SectionTitle'
import SectionBlock from '../SectionBlock'

const ListingTermsSection = ({
  createdAt,
  licenseTerm,
  minimumPrice,
  numberOfLicenses,
  requiredRoyalty,
  usageFee,
  usageLimit
}) => {
  return (
    <SectionBlock>
      <SectionTitle>Listing Terms</SectionTitle>
      <Box className="grid grid-cols-2 gap-2">
        <ItemDetails
          label="License Price:"
          value={minimumPrice}
        />
        <ItemDetails
          label="Royalty:"
          value={`${Number(requiredRoyalty)}%`}
        />
        <ItemDetails
          label="Available Licenses:"
          value={numberOfLicenses}
        />

        <ItemDetails
          label="Usage Limit:"
          value={`${usageLimit} uses`}
        />
        <ItemDetails
          label="Usage Fee:"
          value={`$${usageFee}/use`}
        />
        <ItemDetails
          label="License Term:"
          value={`${licenseTerm} days`}
        />
        <div className="col-span-2">
          <ItemDetails
            label="Listed Date:"
            value={createdAt}
          />
        </div>
      </Box>
    </SectionBlock>
  )
}

export default ListingTermsSection
